import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { map } from 'rxjs/operators';
import { SectionType } from '@core/enums';

@Injectable({
  providedIn: 'root',
})
export class CourseService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  find() {
    return this._http.post<any>(`${this._apiUrl}/allCourses`, {}).pipe(map((res: any) => res.result));
  }

  get(courseId: number) {
    return this._http.get<any>(`${this._apiUrl}/getCoursesById/${courseId}`).pipe(map((res: any) => res.result[0]));
  }

  create(formData: FormData) {
    return this._http.post<any>(`${this._apiUrl}/createCourse`, formData);
  }

  update(id: number, formData: FormData) {
    return this._http.put<any>(`${this._apiUrl}/updateCourse/${id}`, formData);
  }

  delete(courseId: number) {
    return this._http.delete<any>(`${this._apiUrl}/deleteCourse/${courseId}`);
  }

  deleteFile(id: number) {
    return this._http.get(`${this._apiUrl}/delete-image/${SectionType.COURSE}/${id}?attachment=document`);
  }

  getApprovedParticipants(courseId: number) {
    return this._http.get<any>(`${this._apiUrl}/approvedParticipants/course/${courseId}`);
  }

  getUnapprovedParticipants(courseId: number) {
    return this._http.get<any>(`${this._apiUrl}/unapprovedParticipants/course/${courseId}`);
  }

  joinCourse(courseId: number, userId: number) {
    return this._http.post<any>(`${this._apiUrl}/acceptCourseByUnInvited/user/${userId}/course_id/${courseId}`, {});
  }

  commonInfo(teamId: number) {
    return this._http.get<any>(`${this._apiUrl}/courseCommonInfo/${teamId}`).pipe(map((res: any) => res.result));
  }

  downloadDocument(data: any) {
    return this._http.post(`${this._apiUrl}/download-course-document`, data, { responseType: 'blob' });
  }
}
